import React, { Component } from "react";
import { actionCreators } from "../../actions/tagDataAction";
import { actionCreators as filterActions } from "../../actions/searchBarActions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import _ from "lodash";
import styles from "./FilterInfoBar.module.css";

class FilterInfoBar extends Component{

  constructor(props){
    super(props);
    this.state={
      filtersApplied: []
    }
  }

  getFiltersApplied(){
    let filtersApplied = this.props.filters.map((tagid) => {
      if (!this.props.tagData.all_tags) {
        return {};
      }
      return _.find(this.props.tagData.all_tags, (tag) => tag.Tag_ID === tagid);
    });

    return filtersApplied;
  }

  componentDidMount(){
    this.setState({filtersApplied: this.getFiltersApplied()});
  }

  componentDidUpdate(prevProps, prevState){
    if(this.props.filters.length !== prevState.filtersApplied.length){
      this.setState({filtersApplied: this.getFiltersApplied()});
    }
  }

  generateMessage(){
    let msgToShow = "Searching...";
   
    if (this.props.results !== undefined) {
      let searchText = this.props.filterData.searchQuery;

      let msg = `Showing ${this.props.length} of ${this.props.results}`;

      this.state.filtersApplied.length>0 && searchText===""? msg+= ` for ` : msg += ` `;

      if (this.props.results === 0) {
        msgToShow = `No Results Found for "${searchText}"`;
      } else {
        msgToShow = searchText !== "" ? msg + `results for "${searchText}"` : msg;
      }
    }

    return msgToShow;
  
  }

	render(){
    	return (
      		<div className={styles.filterArea}>
        		<div className={styles.result_count_display}>{this.generateMessage()}</div>
				{this.state.filtersApplied.length!==0 || this.props.filterData.searchQuery!==''
					?<div className={styles.clear_filter_button} onClick={e=>this.props.removeAllFilters()}>Clear</div>
		  			:null}
        		<div className={styles.filter_tag_group}>         
          			{this.state.filtersApplied.length > 0 ? this.state.filtersApplied.map((filter,index)=>{
            			return(
              				<div className={styles.filter_tag} type="button" key={index}>
                				{filter.Label}
              				</div>
            			);
					  })
					:null}
		        </div>
      		</div>
    	);
  	}
}

export default connect(
  (state) => {
    const { tagData, filterData } = state;
    return { tagData, filterData };
  },
  (dispatch) =>
    bindActionCreators({ ...actionCreators, ...filterActions }, dispatch)
)(FilterInfoBar);
